import * as React from 'react';
import { AppFactory } from 'app/app-factory';
import { ToastService } from 'common/notifications/toast-service';
import { Toast, ToastTarget } from '../../components/ui/toasts';
import { Outlet } from 'react-router-dom';
import { observer } from 'mobx-react';
import { usePageTracker } from 'lib/hooks/use-page-tracker';

export const AppWideRouteLayout = observer(() => {
  const toast = AppFactory.toastService.current;
  usePageTracker(); // don't track non-authenticated pages until anonymous metrics revisited

  return (
    <>
      <Outlet />
      <ToastTarget
        showNotification={!!toast}
        css={{ '@large': { left: '$$sidebarWidth' }, padding: '$space$2' }}
      >
        {toast ? (
          <Toast
            type={toast.type}
            label={toast.message}
            onDismiss={ToastService.clear}
            action={toast.action}
          />
        ) : null}
      </ToastTarget>
      {AppFactory.dialogPresenter.element}
    </>
  );
});
